import React from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Stack} from '@mui/material';
import {Body, Button, Headline} from '@lightricks/react-design-system';
import onboardingWizardStore, {
  onboardingWizardActions,
  USER_TYPES,
} from '@contentlab/views/contentlab/pages/onboarding-page/onboardingWizardStore';
import translate from '@/utils/translate';
import {ResponsiveStack, SelectionButton} from '../../components';
import getUserTypeInfo from './getUserTypeInfo';

function UserTypeSelectionMenu({onNext}: {onNext: () => void}) {
  const {selectedUserType} = onboardingWizardStore(
    useShallow((state) => ({
      selectedUserType: state.selectedUserType,
    }))
  );

  return (
    <Stack alignItems="center" justifyContent="center" width="100%">
      <ResponsiveStack gap="12px" width="40vw" maxWidth="400px" height="100%">
        <Headline size="lg" marginBottom="-4px">
          {translate('How do you plan to use Ltx Scaler?')}
        </Headline>
        <Body size="lg" marginBottom="24px">
          {translate('Choose the option that best matches your goals.')}
        </Body>
        {Object.values(USER_TYPES).map((userType) => (
          <SelectionButton
            key={userType}
            item={getUserTypeInfo(userType)}
            onClick={() => {
              onboardingWizardActions.setSelectedUserType(userType);
            }}
            isSelected={selectedUserType === userType}
          />
        ))}
        <Button
          sx={{marginTop: '44px'}}
          appearance="neutral"
          mode="filled"
          size="large"
          onClick={onNext}
          disabled={selectedUserType === null}
        >
          {translate('Continue')}
        </Button>
      </ResponsiveStack>
    </Stack>
  );
}

export default UserTypeSelectionMenu;
